import React, { FC } from 'react';

interface Props {
  label: string;
  id?: string;
}

const LabelComponent: FC<Props> = ({ label, id }) => {
  return (
    <label htmlFor={id} className="ml-2 font-bold text-neutral-800 capitalize">
      {label}
    </label>
  );
};

export default LabelComponent;
